module.exports = __webpack_public_path__ + "img/methoden_1920.d1892320.webp";